import React from 'react';

interface ServiceButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  selected?: boolean;
}

const ServiceButton: React.FC<ServiceButtonProps> = ({ icon, label, onClick, selected = false }) => {
  return (
    <button 
      onClick={onClick}
      className={`flex flex-col items-center justify-center w-full p-4 rounded-xl transition-all duration-300 transform ${
        selected 
          ? 'bg-gradient-to-br from-primary/20 to-primary/5 border-2 border-primary shadow-md scale-105' 
          : 'bg-white border-2 border-gray-100 hover:border-primary/30 hover:bg-gray-50 hover:shadow-sm hover:scale-102'
      }`}
    >
      <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-3 transition-all duration-300 ${
        selected 
          ? 'bg-white shadow-md' 
          : 'bg-white'
      }`}>
        <div className="flex items-center justify-center">
          {icon}
        </div>
      </div>
      <span className={`text-sm text-center font-medium transition-colors duration-300 ${selected ? 'text-primary' : 'text-gray-700'}`}>
        {label}
      </span>
    </button>
  );
};

export default ServiceButton; 